import { createApp } from "vue";
import FindSongs from "../Song/FindSongs.vue";
import { initializeArtistSelects } from "../TomSelect/selects";
import { initializeAlbumSelects } from "../TomSelect/selects";

const app = createApp(FindSongs);
app.mount(document.getElementById('foundSongs'));
initializeArtistSelects();
initializeAlbumSelects();

